import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Accordion } from "@cinch-nx/shared-ui";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { Heading, Secondary } from "@cinch-labs/design-system";
import styles from "./store-faqs.module.css";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
export var StoreFaqs = function(param) {
    var title = param.title, faqs = param.faqs;
    var trackEvent = useAnalytics().trackEvent;
    var accordionItems = faqs.map(function(faq) {
        return {
            title: faq.title,
            children: function() {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: renderWithResolver(faq.body, {
                        link: {
                            openNewTab: true,
                            adobeTracking: {
                                eventName: "FAQ link",
                                type: TrackingEventTypes.ADOBE,
                                data: {
                                    action: "click",
                                    event: {
                                        name: EventNames.click,
                                        category: "FAQ link",
                                        label: "".concat(faq.title, " link clicked")
                                    }
                                }
                            }
                        }
                    })
                });
            }
        };
    });
    var FaqCategory = "FAQ accordion";
    var handleItemClick = function(isOpen, title) {
        trackEvent({
            eventName: FaqCategory,
            type: TrackingEventTypes.ADOBE,
            data: {
                action: "".concat(title, " - ").concat(isOpen ? "open" : "close"),
                event: {
                    name: EventNames.click,
                    category: FaqCategory,
                    label: "cinch store"
                }
            }
        });
    };
    var handleCtaClick = function() {
        trackEvent({
            eventName: FaqCategory,
            type: TrackingEventTypes.ADOBE,
            data: {
                action: "View all FAQs",
                event: {
                    name: EventNames.click,
                    category: FaqCategory,
                    label: "cinch store"
                }
            }
        });
    };
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                id: "faq-section",
                className: styles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx(Accordion, {
                title: title,
                items: accordionItems,
                buttonId: title,
                sectionId: "store-faq-section",
                onItemToggle: function(itemIndex, isOpen) {
                    return handleItemClick(isOpen, title);
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.cantFindWhatYoureLookingFor,
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        children: "Can’t find what you’re looking for?"
                    }),
                    /*#__PURE__*/ _jsx(Secondary, {
                        classNames: {
                            button: styles.button
                        },
                        element: "a",
                        href: "/support",
                        onClick: function() {
                            return handleCtaClick();
                        },
                        children: "View all FAQs"
                    })
                ]
            })
        ]
    });
};
